import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCardsBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="m10.952 19.464 2.59.39c.208.03.232.321.032.387l-3.336 1.097a4.9 4.9 0 0 1-1.529.256c-1.853 0-3.405-1.182-4.087-3.243L2.597 12.19c-.43-1.291-.379-2.578.147-3.622.503-1.001 1.401-1.737 2.596-2.13l1.437-.471c.11-.036.219.059.202.173l-.96 6.42c-.532 3.546 1.496 6.385 4.933 6.904"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      d="M16.395 18.709q-.372 0-.764-.057l-4.452-.671c-2.605-.392-4.082-2.482-3.674-5.198l.96-6.42c.407-2.717 2.424-4.28 5.033-3.9h.002l.003.001 4.449.67c2.605.393 4.08 2.482 3.673 5.198l-.96 6.42c-.367 2.443-2.042 3.957-4.27 3.957"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCardsBulk);
export default ForwardRef;
